import React from 'react';
import { ArhidekoLogo } from './ArhidekoLogo';
import { BuildhubLogo } from './BuildhubLogo';
import { CreatonStudioLogo } from './CreatonStudioLogo';
import { CraftAndCodeLogo } from './CraftAndCodeLogo';
import { KateInteriorsLogo } from './KateInteriorsLogo';
import { VenturelabLogo } from './VenturelabLogo';

export const logoMap: { [key: string]: React.FC } = {
  arhideko: ArhidekoLogo,
  buildhub: BuildhubLogo,
  creaton: CreatonStudioLogo,
  craftcode: CraftAndCodeLogo,
  kateinteriors: KateInteriorsLogo,
  venturelab: VenturelabLogo,
};
